export const globalSearchTranslationsEN = {
  searchPlaceholder: 'Search...',
  searchExplanation: 'Enter at least 3 characters to start searching.',
  hint: 'Hint:',
  exactSearchExplanationBefore: 'Use',
  exactSearchExplanationAfter: 'for exact search.',
  escExplanationBefore: 'Press',
  escExplanationAfter: 'to close the search.',
  noResultsFound: 'No results found',
  recentSearches: 'Recent Searches',
} as const;
